import moment from 'moment'

export const informationDefault = () => {
    return {
        key: undefined,
        channel: null,
        channel_id: null,
        channel_short_name: null,
        channel_order: undefined,
        order_date: moment().format("MM/DD/YYYY HH:mm"),
        order_date_utc: new Date(),
        ref: undefined,
        customer: undefined,
        channel_customer: undefined,
        name: undefined,
        yomigana: undefined,
        phone: undefined,
        email: undefined,
        country: undefined,
        postal_code: undefined,
        address1: undefined,
        address2: undefined,
        address3: undefined,
        address4: undefined,
        address_type: "1",
        terms: "2",
        preferred_time: "00",
        currency: "JPY",
    }
}

export const informationClassesDefault = () => {
    return {
        channel: '',
        channel_order: '',
        order_date: '',
        ref: '',
        customer: '',
        channel_customer: '',
        name: '',
        yomigana: '',
        phone: '',
        email: '',
        country: '',
        postal_code: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        address_type: '',
        terms: '',
        preferred_time: '',
        currency: ''
    }
}



// WEBPACK FOOTER //
// ./src/reducers/helper/stateDefaultOrder.js